import { useEffect, useState } from 'react';

export const useDebounce = <T>(value: T, delay: number = 300): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const useDebouncedState = <T>(
  initialValue: T,
  delay: number = 300,
): [T, (value: T) => void, T] => {
  const [value, setValue] = useState<T>(initialValue);
  const debouncedValue = useDebounce<T>(value, delay);

  return [debouncedValue, setValue, value];
};
